import CrudManager from "@/components/admin/CrudManager";

export default function VehiclesAdmin() {
  return (
    <CrudManager
      title="Fleet" subtitle="Manage taxi vehicles shown on the website." testid="admin-vehicles"
      endpoint={{ public: "/vehicles", admin: "/admin/vehicles" }} queryKey="vehicles"
      columns={[
        { key: "image", label: "Image", render: (v) => <img src={v.image} alt="" className="h-10 w-16 object-cover rounded-lg" /> },
        { key: "name", label: "Name" },
        { key: "category", label: "Category" },
        { key: "seating", label: "Seating" },
      ]}
      fields={[
        { key: "name", label: "Vehicle Name" },
        { key: "category", label: "Category", type: "select", options: ["Sedan", "SUV", "Premium SUV", "Tempo Traveller"] },
        { key: "seating", label: "Seating Capacity" },
        { key: "luggage", label: "Luggage Capacity" },
        { key: "examples", label: "Example Models" },
        { key: "ac", label: "AC", type: "checkbox", checkboxLabel: "Air Conditioned" },
        { key: "suitable_for", label: "Suitable For", type: "textarea", rows: 2 },
        { key: "image", label: "Image URL", type: "image", full: true },
        { key: "order", label: "Sort Order", type: "number" },
      ]}
    />
  );
}
